/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimeOffUpdatesRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetTimeOffUpdatesResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getTimeOffUpdates = (request: GetTimeOffUpdatesRequest, options?: CashRequestOptions) => post<GetTimeOffUpdatesRequest, GetTimeOffUpdatesResponse>("/2.0/cash/get-time-off-updates", request, {...options, rejectOnError: true })